import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { twMerge } from "../../../node_modules/tailwind-merge/dist/bundle-mjs.js";
const Navbar = forwardRef((props, ref) => {
  const { children, className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    "nav",
    {
      ...rest,
      ref,
      className: twMerge(
        "fixed w-full h-[var(--navbar-height)] border-b border-[rgb(234,237,242)] bg-white flex items-center",
        className
      ),
      children
    }
  );
});
export {
  Navbar as default
};
//# sourceMappingURL=Navbar.js.map
